import { FiGithub } from "react-icons/fi";
import { AiOutlineInstagram } from "react-icons/ai";
import { FaLinkedin } from "react-icons/fa";
import "./animation.css";
import { useState, useEffect, useRef } from "react";
const Hero = (props) => {
  const aboutMeRef = useRef(null);

  const handleClick = () => {
    if (aboutMeRef && aboutMeRef.current) {
      aboutMeRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };



  return (
    <div className="bg-background">
      <div className="fade-in grid grid-cols-10 md:grid-cols-100 gap-4 min-h-screen">
        <div className="md:col-span-1 hidden md:block col-start-1 col-end-5">
          <div className="grid columns-1 justify-center h-full">
            <div className="fixed bottom-0  left-[5%]">
              <a
                href="https://github.com/rainisthename"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FiGithub className="text-gray-400 text-1xl mb-5 hover:-translate-y-1 transition duration-500 ease-in-out hover:text-header hover:cursor-pointer" />
              </a>
              <a
                href="https://www.instagram.com/lstrbumbilya/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <AiOutlineInstagram className="text-gray-400 text-1xl mb-5 hover:-translate-y-1 transition duration-500 ease-in-out hover:text-header hover:cursor-pointer" />
              </a>
              <a
                href="https://www.linkedin.com/in/marklstrcaletina"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin className="text-gray-400 text-1xl mb-5 hover:-translate-y-1 transition duration-500 ease-in-out hover:text-header hover:cursor-pointer" />
              </a>
              <div className="h-10 w-0.5 bg-gray-400 mx-auto"></div>
            </div>
          </div>
        </div>

        {/**/}
        <div className="md:col-span-1 hidden md:block col-start-6 col-end-15"></div>
        <div className="col-span-10 md:col-span-6 md:col-span-70 flex">
          <div className="self-center mx-5">
            <p className="font-SFMONO text-header text-sm pb-2  ">
              Hello, my name is
            </p>
            <p className="text-gray-200 font-sans-bold text-5xl pb-7">
              Mark Lester Caletina.
            </p>

            <p className="text-justify text-gray-400 font-sans pb-6 md:text-sm text-xs">
            I'm a dedicated developer specializing in frontend development and full-stack technologies. With a passion for creating visually appealing and user-friendly interfaces, I've honed my skills in web development and mobile applications. Keeping myself updated with the latest design trends and technological advancements is a top priority, ensuring that my work remains cutting-edge and impactful. Collaboration with innovative teams and a drive to continuously learn and grow define my approach as I strive to make a meaningful impact with my expertise as a developer.





            </p>
            <button
              onClick={handleClick}
              className="text-white border text-xs py-3 px-8 rounded font-sans hover:bg-header hover:text-black hover:-translate-y-1 transition duration-500 ease-in-out"
            >
              About Me
            </button>
          </div>
        </div>
        <div className="md:col-span-1 hidden md:block col-start-85 col-end-90">
          <div className="grid columns-1">
            <div className="self-end  ">
              <div className="fixed bottom-0  right-[5%]">
                <a href="mailto:caletina.marklester@gmail.com">
                  <p
                    className="text-gray-400 font-sans text-sm pb-2 hover:-translate-y-1 transition duration-500 ease-in-out hover:text-header hover:cursor-pointer"
                    style={{ writingMode: "vertical-lr" }}
                  >
                    caletina.marklester@gmail.com
                  </p>
                </a>
                <div className="h-10 w-0.5 bg-gray-400 mx-auto"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="md:col-span-1 hidden md:block col-start-91 col-end-100"></div>
      </div>
      <div
        className="bg-background h-[50vh] flex justify-center items-center"
        ref={aboutMeRef}
      >
        <div className="md:w-2/5 mx-5 fade-in">
          <div className="flex items-center pb-4 ">
            <div className="text-gray-200 text-2xl font-sans-semibold">
              About Me
            </div>
            <div className="border-b border-gray-600 h-0.02 md:h-0.06 ml-4 flex-grow"></div>
          </div>
          <p className="text-gray-400 font-sans text-sm text-justify  ">
            Hello, my name is Mark and I'm a web developer with a passion for
            creating beautiful, functional websites. I've worked with several
            programming companies as an intern during my early college years to
            gain experience because I wanted to become proficient and gain
            experience as soon as possible.
          </p>
          <p className="text-gray-400 font-sans text-sm text-justify  pt-5">
            I am always eager to collaborate and jump into exciting projects. I
            believe that working together with others can bring fresh
            perspectives and help us achieve great results. Whether it's
            developing new features or improving existing ones, I am always
            ready to contribute my skills and knowledge. So, if you have an
            exciting project in mind, don't hesitate to reach out to me.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Hero;
